module.exports = __webpack_public_path__ + "img/icon.9e87d3b4.svg";